/**
 * Legacy RulesEngineApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.rulesEngineApi`) keep resolving.
 *
 * The actual RulesEngineApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/rules-engine/rules-engine-api.service.ts
 */
angular.module("acme.common.service.rulesEngineApi", [
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
